export default ({ route, store }) => {
  if (route.path.includes('/photo/')) {
    store.dispatch('setHeader', false)
  } else {
    store.dispatch('setHeader', true)
  }
}
